import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-45px me-5" }
const _hoisted_11 = {
  key: 0,
  alt: "Pic",
  src: ''
}
const _hoisted_12 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_13 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_14 = {
  href: "#",
  class: "text-muted text-hover-primary fw-bold text-muted d-block fs-7"
}
const _hoisted_15 = { class: "badge-light-primary badge" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "svg-icon svg-icon-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppraisalsAdvancedSearch = _resolveComponent("AppraisalsAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppraisalsAdvancedSearch, {
            onTypeSelected: _ctx.onFilterChange,
            onReset: _ctx.onResetFilters
          }, null, 8, ["onTypeSelected", "onReset"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary d-none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('appraisals-creating')))
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewAdmin')), 1)
          ])
        ])
      ])
    ]),
    (_ctx.can('read', 'official-appraisal'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-applicantName": _withCtx(({ row: appraisal }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  false
                    ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                    : true
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass([`bg-light-${'success'} text-${'success'}`, "symbol-label fw-bolder"])
                        }, _toDisplayString(appraisal.applicantName.charAt(0)), 1))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, _toDisplayString(appraisal.applicantName), 1),
                  _createElementVNode("a", _hoisted_14, _toDisplayString(appraisal.applicantEmail), 1)
                ])
              ])
            ]),
            "cell-appraiserName": _withCtx(({ row: appraisal }) => [
              _createTextVNode(_toDisplayString(appraisal.appraiserName), 1)
            ]),
            "cell-areaName": _withCtx(({ row: appraisal }) => [
              _createTextVNode(_toDisplayString(appraisal.areaName), 1)
            ]),
            "cell-price": _withCtx(({ row: appraisal }) => [
              _createTextVNode(_toDisplayString(appraisal.price), 1)
            ]),
            "cell-statusTitle": _withCtx(({ row: appraisal }) => [
              _createElementVNode("span", _hoisted_15, _toDisplayString(appraisal.statusTitle), 1)
            ]),
            "cell-createdAt": _withCtx(({ row: appraisal }) => [
              _createTextVNode(_toDisplayString(appraisal.createdAt), 1)
            ]),
            "cell-actions": _withCtx(({ row: appraisal }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editAppraisal(appraisal.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                ])
              ], 8, _hoisted_16),
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                onClick: _withModifiers(($event: any) => (_ctx.viewAppraisal(appraisal.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ])
              ], 8, _hoisted_18)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}